var module = angular.module('octopusApp.projects');

module.controller('ProjectReleasesController', function ($scope, busy, $stateParams, projectState, pageTitle, octopusRepository) {
    var isLoading = $scope.isLoading = busy.create();
    var projectId = $stateParams.projectId;
    $scope.filter = {};
    $scope.refresh = refresh;
    $scope.channels = [];

    isLoading.promise(projectState.load().then(function (project) {
        pageTitle(project.Name + " releases");
        $scope.project = project;

        isLoading.promise(projectState.deploymentProcessAsync.then(function (deploymentProcess) {

            refresh();
            $scope.deploymentProcess = deploymentProcess;
        }, function () {
            $scope.project = project;
        }));

        isLoading.promise(octopusRepository.Projects.getChannels(project).then(function (channels) {
            $scope.channels = channels;
        }));
    }));

    function refresh() {
        loadReleases();
    }

    function loadReleases() {
        var channelId = $scope.filter.channelId;

        if (channelId) {
            isLoading.promise(octopusRepository.Channels.get(channelId).then(function (channel) {
                isLoading.promise(octopusRepository.Channels.getReleases(channel, {skip: $scope.skip}).then(function (releases) {
                    $scope.releases = releases;
                }));
            }));
        }
        else {
            isLoading.promise(octopusRepository.Projects.getReleases($scope.project, {skip: $scope.skip}).then(function (releases) {
                $scope.releases = releases;
            }));
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/controllers/project_releases_controller.js
// module id = 2774658850592374
// module chunks = 1